import { MutationOptions, useMutation } from 'react-query';

import { convertEmptyStringToNull } from '@app/features/addressBook/libs';
import {
  createContact,
  CreateContactParams,
  CreateContactResponse,
} from '@app/store/transport-layer/document/address-book/contacts';

export default function useCreateContact(
  options?: MutationOptions<CreateContactResponse, Error, CreateContactParams>
) {
  return useMutation<CreateContactResponse, Error, CreateContactParams>(
    ({
      bizNumber,
      companyName,
      defaultForwardingMethod,
      departmentPosition,
      description,
      email,
      name,
      phoneNumber,
    }) =>
      createContact({
        bizNumber: convertEmptyStringToNull(bizNumber),
        companyName: convertEmptyStringToNull(companyName),
        defaultForwardingMethod,
        departmentPosition: convertEmptyStringToNull(departmentPosition),
        description: convertEmptyStringToNull(description),
        email: convertEmptyStringToNull(email),
        name,
        phoneNumber: convertEmptyStringToNull(phoneNumber),
      }),
    options
  );
}
